<div *ngIf="steps?.length > 0">
	<h4>Test case steps</h4>
	<div>
		<table mat-table [dataSource]="dataSource">
			<ng-container matColumnDef="step number">
				<th mat-header-cell *matHeaderCellDef width="50px">Step</th>
				<td mat-cell *matCellDef="let element">{{ element.stepNo === 0 ? '' : element.stepNo }}</td>
			</ng-container>
			<ng-container matColumnDef="precondition">
				<th mat-header-cell *matHeaderCellDef>Precondition</th>
				<td mat-cell *matCellDef="let element">{{ element.precondition }}</td>
			</ng-container>
			<ng-container matColumnDef="stimuli">
				<th mat-header-cell *matHeaderCellDef>Stimuli</th>
				<td mat-cell *matCellDef="let element">{{ element.stimuli }}</td>
			</ng-container>
			<ng-container matColumnDef="expected response">
				<th mat-header-cell *matHeaderCellDef>Expected response</th>
				<td mat-cell *matCellDef="let element">{{ element.expectedResponse }}</td>
			</ng-container>
			<ng-container matColumnDef="postcondition">
				<th mat-header-cell *matHeaderCellDef>Postcondition</th>
				<td mat-cell *matCellDef="let element">{{ element.postcondition }}</td>
			</ng-container>
			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
		</table>
	</div>
</div>
<div *ngIf="steps?.length === 0" class="normal-text">There are no steps for this test case</div>
